import { render } from "./MFAComponent.vue?vue&type=template&id=5372b02f"
import script from "./MFAComponent.vue?vue&type=script&lang=js"
export * from "./MFAComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__